import { API_CONFIG } from '../config/api';

interface SignedUrlResponse {
  signed_url?: string;
}

const ensureLeadingSlash = (path: string): string => {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return path.startsWith('/') ? path : `/${path}`;
};

/**
 * Fetches a short-lived signed URL for protected media resources.
 */
export const fetchSignedMediaUrl = async (path: string, token: string): Promise<string> => {
  const targetPath = ensureLeadingSlash(path);
  const response = await fetch(`${API_CONFIG.BASE_URL}${targetPath}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch signed URL (${response.status})`);
  }

  const data: SignedUrlResponse = await response.json();
  if (!data.signed_url) {
    throw new Error('Signed URL not found in response');
  }

  return data.signed_url;
};
